import { useMemo } from 'react';

import { Skeleton } from '~/components/Skeleton';
import { cn } from '~/lib/cn';
import { TableCell, TableRow } from '~/modules/artist-roster/components/Table';

interface SkeletonTableProps {
  size: number;
  headers: { id: string }[];
  cellClassName?: string;
  firstLineClassName?: string;
  secondLineClassName?: string;
}

export function SkeletonTable({
  size,
  headers,
  firstLineClassName,
  secondLineClassName,
  cellClassName,
}: SkeletonTableProps) {
  const items = useMemo(() => Array.from({ length: size }), [size]);

  return items.map((_, i) => (
    <TableRow key={i} data-testid={`skeleton-table-row-${i}`}>
      {headers.map((cell) => (
        <TableCell
          key={cell.id}
          className={cn(
            'border-y py-md border-transparent first:rounded-l-sm first:pl-lg last:rounded-r-sm last:pr-lg',
            i % 2 === 0 && 'bg-default-inverse/default',
            cellClassName,
          )}
        >
          <div className="space-y-sm">
            <Skeleton
              className={cn(
                'h-md w-[10em] max-w-full rounded-sm bg-level-04',
                firstLineClassName,
              )}
            />
            <Skeleton
              className={cn(
                'h-md w-[8em] max-w-full rounded-sm bg-level-04',
                secondLineClassName,
              )}
            />
          </div>
        </TableCell>
      ))}
    </TableRow>
  ));
}
